import type { User } from '~/shared/user/user.supabase.schema'

/**
 * Feature flags that can be enabled per entity
 */
export const FeatureFlag = {
  PROPOSAL_ASSISTANT: 'proposal_assistant',
  PROPOSAL_ASSISTANT_INBOUND_EMAILS: 'proposal_assistant_inbound_emails',
  SUMMARIZE_EVENT_FOR_EMAIL: 'summarize_event_for_email',
  CALCULATE_TRAVEL_TIMES: 'calculate_travel_times',
  SPACE_CARD_AI_BLURB_BULLETS: 'space_card_ai_blurb_bullets',
  NOTABLE_CHEF_AI_TAG_FILTER: 'notable_chef_ai_tag_filter',
  COLLECTIONS: 'collections',
  SLIDE_STUDIO: 'slide_studio',
  PREFERRED_VENUE_CONTACTS: 'preferred_venue_contacts',
  EMAIL_INBOX: 'email_inbox',
  EXPERIMENTAL_AI_TAG_FILTERS: 'experimental_ai_tag_filters',
  EDITORIAL_RECOGNITION_FILTERS: 'editorial_recognition_filters',
  VENUE_TAGS: 'venue_tags',
  SORT_SPACE_RESULTS: 'sort_space_results',
  HOSPITALITY_GROUPS_FILTER: 'hospitality_groups_filter',
} as const

export type FeatureFlagValue = (typeof FeatureFlag)[keyof typeof FeatureFlag]

/**
 * Check if a user has a specific feature enabled
 */
export function hasFeature(userDetail: User | null | undefined, feature: FeatureFlagValue): boolean {
  return userDetail?.active_entity?.features?.includes(feature) || false
}
